import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import Error404 from "../../../../../Error404";
import {mainParticipationDataAPI, mainParticipationSAVEDataAPI} from "../../../../../../services/api/project";
import "bootstrap/dist/css/bootstrap.min.css";
import DarkCard from "../../../../../../components/card/DarkCard";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { Colors } from "../../../../../../components/theme";

// Styled component for table headers with smooth visibility transition
const TableHeader = styled.th`
    transition: min-width 0.3s ease-in-out, opacity 0.3s ease-in-out;
    cursor: pointer;
    text-align: left;
    width: ${(props) => (props.isHidden ? "80px" : "auto")};
    &:hover {
        opacity: 0.7;
    }
`;

// Styled component for table cells with visibility transition
const TableCell = styled.td`
    transition: min-width 0.3s ease-in-out, opacity 0.3s ease-in-out;
    width: ${(props) => (props.isHidden ? "80px" : "auto")};
    text-align: left;
    white-space: nowrap;
`;

const TxtTitlesTable = styled.p`
	font-size: 0.7em;
    text-transform: uppercase;
	width: 100%;
    padding: 5px 0 0 0;
    margin: 0;
    color: ${Colors.darkRed};
`;


const MainParticipationView = () => {
    const { t } = useTranslation();
    // const [data, setData] = useState({});
    const [projects, setProjects] = useState([]); // lista projektow
    const [users, setUsers] = useState([]);       // lista muzykow
    const [visibleColumns, setVisibleColumns] = useState({ telephone: true, mail: true });
    const [copySuccess, setCopySuccess] = useState(null);

    useEffect(() => {
        const get_DataAPI = async () => {
            const response = await mainParticipationDataAPI();
            if (response.status === 200) {
                // console.log("RESPONSE:", response.data);
                setProjects(response.data.projects_list);
                setUsers(response.data.users);
            } else {
                return <Error404 />;
            }
        };
        get_DataAPI();
    }, []);

    const handleCopyEmail = (email) => {
        if (email) {
            navigator.clipboard.writeText(email);
            setCopySuccess(t("project.availabilities.mail_copy_message", { email: email}));

            // Close alert after 5 seconds
            setTimeout(() => {
                setCopySuccess(null);
            }, 5000);
        }
    };

    // Function for switching the visibility of a column
    const toggleColumn = (columnKey) => {
        setVisibleColumns((prevState) => ({
            ...prevState,
            [columnKey]: !prevState[columnKey],
        }));
    };

    const extractMusParticipationStatus = (projectID, participation_list) => {
        const participationStatus = participation_list.find(entry => Object.keys(entry).includes(String(projectID)))
        return participationStatus ? participationStatus[projectID] : " ";
    }

    const ChangeHandler = (val, projectID, userID) => {
        // zapis do bazy i odświeżenie strony
        const newData = {
            projectID: projectID,
            userID: userID,
            status: val,
        }
        const save_data =async () => {
            const response = await mainParticipationSAVEDataAPI(newData)
            if (response.status === 200) {
                const usersCopy = structuredClone(users)
                const user = usersCopy.find(entry => entry.user_id === userID)

                if (user) {
                    let participationStatus = user.participation.find(entry => Object.keys(entry).includes(String(projectID)))
                    if (participationStatus) {
                        participationStatus[projectID] = val
                    } else {
                        user.participation = [...user.participation ,{[projectID]: val}]
                    }
                    setUsers(usersCopy)
                }
            } else {
                console.log("ERROR>>>>>>: ", response)
            }
            
        }
        save_data();

    }

    console.log("USERS: ", users)
    console.log("PROJECTS: ", projects)

    return (
        <>
            {copySuccess && (
                <div className="alert alert-success fade show mt-3" role="alert"
                style={{
                    position: "fixed",
                    top: "10px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    zIndex: 1050,
                }}>
                    {copySuccess}
                </div>
            )}
    
            <DarkCard classNames="mb-3 row">
                <p className="m-0 p-0 breadcrumbs">
                    <span className="txt">{t("menu.projects", { ns: "menu" })}</span> &#9656;
                    <Link to={"/projects/main-participation-view"}>{t("menu.main_participation_view", { ns: "menu" })}</Link>
                </p>
            </DarkCard>
            <DarkCard classNames="mb-3 row">
                <h1 className="mb-0 mt-0 p-0" style={{ marginTop: "-5px" }}>
                    {t("project.availabilities.page_title")}
                </h1>
                <div className="table-responsive">
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">{t("project.availabilities.table_mus_title")}</th>
                                <TableHeader
                                    scope="col"
                                    onClick={() => toggleColumn("phone")}
                                    isHidden={!visibleColumns.telephone}
                                >
                                    {t("project.availabilities.table_mus_phone_title")}
                                </TableHeader>
                                <TableHeader
                                    scope="col"
                                    onClick={() => toggleColumn("email")}
                                    isHidden={!visibleColumns.mail}
                                >
                                    {t("project.availabilities.table_mus_email_title")}
                                </TableHeader>
                                {projects.map((project, index) => (
                                    <th scope="col" key={"project_"+index}>
                                        <TxtTitlesTable style={{ textAlign:"center" }}>ID: {project.project_current_id}</TxtTitlesTable>
                                        <p style={{ textAlign:"center" }} className="mb-1">{project.name}</p>
                                        <TxtTitlesTable style={{ textAlign:"center" }}>Start</TxtTitlesTable>
                                        <p style={{ fontWeight: "normal", textAlign:"center" }} className="mb-1">{project.first_date || "-"}</p>
                                        <TxtTitlesTable style={{ textAlign:"center" }}>Concert/s</TxtTitlesTable>
                                        <p style={{ fontWeight: "normal", textAlign:"center" }} className="mb-1">{project.first_date || "-"}</p>
                                        <TxtTitlesTable style={{ textAlign:"center" }}>Direction</TxtTitlesTable>
                                        <p style={{ fontWeight: "normal", textAlign:"center" }} className="mb-1">{project.direction || "-"}</p>
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>

                        {
                            users.length > 0 &&
                                users.map((user, index) => (
                                    <tr key={"user_"+index}>

                                        {user[0] && (<>
                                            <td>{user[0]}</td>
                                            {
                                                user[1] && (

                                                    user[1].map((entry, lp) => (
                                                        <>
                                                            <th scope="row">{lp + 1}</th>
                                                            <td>{entry.username}</td>
                                                            <TableCell isHidden={!visibleColumns.telephone}>
                                                                {visibleColumns.telephone ? entry.telephone || "-" : " - "}
                                                            </TableCell>
                                                            <TableCell
                                                                isHidden={!visibleColumns.mail}
                                                                onClick={() => handleCopyEmail(entry.mail)}
                                                                style={{ cursor: visibleColumns.mail && entry.mail ? "pointer" : "default" }}
                                                            >
                                                                {visibleColumns.mail ? entry.mail || "-" : " - "}
                                                            </TableCell>

                                                        </>
                                                    ))

                                                    )
                                        }


                                        </>)}

                                    </tr>
                                ))

                        }


                        </tbody>
                    </table>
                </div>
            </DarkCard>
        </>
    );
};

export default MainParticipationView;